import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { Window } from '../../reducers/window';
import { mapStateToProps } from '../../utils/mapper';
import { body, colors, subHeader } from '../../utils/styles';

import Check from '../../modules/svgs/check';
import ErrorX from '../../modules/svgs/error_x';

const styles = (multiplier) => ({
  active: RX.Styles.createViewStyle({
    backgroundColor: '#4b94ce',
  }),
  buttonSet: RX.Styles.createViewStyle({
    flexDirection: 'row',
    overflow: 'visible',
  }),
  buttonText: RX.Styles.createTextStyle({
    color: 'black',
    flexWrap: 'wrap',
    letterSpacing: 0.4,
    textAlign: 'center',
    textAlignVertical: 'center',
  }),
  label: RX.Styles.createTextStyle({
    color: '#666666',
    marginBottom: 12 * multiplier,
    marginTop: 16 * multiplier
  }),
  leftRadius: RX.Styles.createViewStyle({
    borderBottomLeftRadius: 5,
    borderTopLeftRadius: 5,
  }),
  normalRadius: RX.Styles.createViewStyle({
    borderRadius: 0,
  }),
  rigthRadius: RX.Styles.createViewStyle({
    borderBottomRightRadius: 5,
    borderTopRightRadius: 5,
  }),
  roundButton: RX.Styles.createViewStyle({
    alignItems: 'center',
    backgroundColor: colors.white,
    borderColor: '#cccccc',
    borderWidth: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: 18 * multiplier,
    paddingLeft: 30 * multiplier,
    paddingRight: 30 * multiplier,
  }),
  roundRedButton: RX.Styles.createViewStyle({
    alignItems: 'center',
    backgroundColor: colors.white,
    borderColor: 'rgb(160, 6, 45)',
    borderWidth: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: 18 * multiplier,
    paddingLeft: 30 * multiplier,
    paddingRight: 30 * multiplier,
  }),
  textWidths: RX.Styles.createViewStyle({
    maxWidth: (250 - 24) * multiplier,
    minWidth: (100 - 24) * multiplier
  }),
  widths: RX.Styles.createViewStyle({
    maxWidth: 250 * multiplier,
    minWidth: 100 * multiplier
  }),
});

interface ButtonSetState {
  active?: string;
  buttonHeight: number;
  focus?: string;
};

interface Option {
  label: string,
  value?: string | number
  svg?: any;
};

interface ButtonSetProps {
  options: Option[],
  label: string,
  onChange?: ({ value }: { value: any }) => void;
  active?: string | undefined;
  window: Window & { multiplier: number };
  test?: boolean;
  required?: boolean;
  showError?: boolean;
  labelId: string;
}

export class ButtonSet extends RX.Component<ButtonSetProps, RX.CommonProps & ButtonSetState> {
  public static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (nextProps.test) {
      return null;
    }

    if (nextProps.active !== prevState.active) {
      return { active: nextProps.active };
    } else {
      return null;
    }
  }

  constructor(props: ButtonSetProps) {
    super(props);
    this.state = {
      active: props.active,
      buttonHeight: 0,
      focus: '',
    };
    this.onPress = this.onPress.bind(this);
    this.focus = this.focus.bind(this);
    this.unfocus = this.unfocus.bind(this);
  }

  public render() {
    let { window: { width } } = this.props
    // tslint:disable:max-line-length
    const { label, labelId, options,  window: { multiplier, landscape }, required = true, showError = false } = this.props;
    const web = RX.Platform.getType() === 'web';

    const outsideWidth = (landscape ? 112 : 64) * multiplier;
    const extraWidth = (width - outsideWidth - options.length) % options.length;
    const widthPercentage = Math.floor((width - outsideWidth) / options.length);
    width = width - outsideWidth * multiplier;

    // tslint:disable:max-line-length
    return (
      <RX.View>
        <RX.Text id={labelId} style={[subHeader(multiplier), styles(multiplier).label]}>{label}{required && !this.state.active && <RX.Text style={{ color: colors.alert }}> *</RX.Text>}</RX.Text>
        {showError && <RX.Text style={{ color: colors.alert, fontWeight: 'bold', fontSize: 16 * multiplier  }}>This field is required.</RX.Text>}
        <RX.View style={[styles(multiplier).buttonSet, { width }]}>
          {
            options.map(({ label: optionLabel, value, svg }, idx) => {
            return (
              <RX.Button
                key={optionLabel}
                style={[
                  (idx === 0) ? styles(multiplier).leftRadius : ((idx + 1) === options.length) ? styles(multiplier).rigthRadius : styles(multiplier).normalRadius,
                   styles(multiplier).roundButton,
                  {
                    backgroundColor: this.state.active === value ? colors.secondary : this.state.focus === value ? colors.primary : colors.white,
                  },
                  width < 992 - outsideWidth
                    ? {
                      width: (idx + 1) * multiplier < extraWidth
                        ? widthPercentage + 1 * multiplier
                        : widthPercentage - (40 / options.length) // (40/options.length) right gutter space for the check and cross icon
                    }
                    : styles(multiplier).widths,
                  { marginLeft: idx !== 0 ? -3 * multiplier : 0 },
                ]}
                onPress={() => this.onPress(value)}
                onBlur={() => this.unfocus()}
                onFocus={() => this.focus(value)}
              >
                {svg && RX.createElement(svg, { style: { color: this.state.active === value || this.state.focus === value ? colors.white : colors.primary, height: 35 * multiplier, width: 35 * multiplier } })}
                <RX.Text
                  style={[
                    body(multiplier),
                    styles(multiplier).buttonText,
                    { marginTop: svg ? 8 : 0, color: this.state.active === value || this.state.focus === value ? colors.white : colors.black },
                    width < 992 - outsideWidth
                      ? {
                        width: idx + 1 < extraWidth
                          ? !web && svg ? widthPercentage : widthPercentage + 1 - 20
                          : !web && svg ? widthPercentage : widthPercentage - 22
                      }
                      : styles(multiplier).textWidths,
                  ]}
                >
                  {optionLabel}
                </RX.Text>
              </RX.Button>
              )
            }
          )}

          {(required && this.state.active) && RX.createElement(Check, { style: { color: this.state.active === 'gray' || this.state.focus === 'value' ? colors.white : colors.green,  height: 35 * multiplier, width: 35 * multiplier, minWidth: 20 * multiplier } })}
          {(required && showError ) && RX.createElement(ErrorX, { style: { color: this.state.active === 'gray' || this.state.focus === 'value' ? colors.white : colors.red, height: 35 * multiplier, width: 35 * multiplier, minWidth: 20 * multiplier } })}

        </RX.View>

      </RX.View>
    );
  }

  private onPress(val: any) {
    const { onChange } = this.props;
    const value = this.state.active === val && this.state.focus !== val ? '' : val;
    this.setState({ active: value, focus: '' });
    onChange && onChange({ value }); //tslint:disable-line
  }

  private focus(val: any) {
    const value = this.state.focus === val ? '' : val;
    this.setState({ focus: value });
  }

  private unfocus() {
    this.setState({ focus: '' });
  }
}

export default connect(mapStateToProps)(ButtonSet);



// WEBPACK FOOTER //
// ./src/components/button_set/index.tsx